import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/store'

Vue.use(VueRouter)

const routes = [
    {
        path: "/",
        meta: { requiresAuth: true },
        component: () => import('@templates/default/Index.vue'),
        children: [
            {
                path: '',
                name: 'Home',
                meta: { allowWithoutEmpresa: true },
                component: () => import('@pages/Home/Home.vue')
            },
            {
                path: 'empresa',
                name: 'EmpresaList',
                meta: {
                    allowWithoutEmpresa: true,
                    title: "Empresas",
                },
                component: () => import('@pages/Empresa/Empresa.vue')
            },
            {
                path: 'empresa/create',
                name: 'EmpresaCreate',
                meta: {
                    allowWithoutEmpresa: true,
                    title: "Cadastro de Usuário",
                },
                component: () => import('@pages/Empresa/EmpresaCreate.vue')
            },
            {
                path: 'empresa/edit/:id',
                props: true,
                name: 'EmpresaEdit',
                meta: {
                    allowWithoutEmpresa: true,
                    title: "Edição de Usuário",
                },
                component: () => import('@pages/Empresa/EmpresaEdit.vue')
            },
            {
                path: 'empresa/troca',
                name: 'EmpresaChange',
                meta: {
                    allowWithoutEmpresa: true,
                    title: "Empresas",
                },
                component: () => import('@pages/Empresa/EmpresaChange.vue')
            },
            {
                path: 'usuario',
                name: 'UsuarioList',
                meta: {
                    allowWithoutEmpresa: true,
                    title: "Usuários",
                },
                component: () => import('@pages/Usuario/Usuario.vue')
            },
            {
                path: 'usuario/create',
                name: 'UsuarioCreate',
                meta: {
                    allowWithoutEmpresa: true,
                    title: "Cadastro de Usuário",
                    permissions: 'admin'
                },
                component: () => import('@pages/Usuario/UsuarioCreate.vue')
            },
            {
                path: 'usuario/edit/:id',
                props: true,
                name: 'UsuarioEdit',
                meta: {
                    allowWithoutEmpresa: true,
                    title: "Edição de Usuário",
                },
                component: () => import('@pages/Usuario/UsuarioEdit.vue')
            },
            {
                path: 'usuario/editpassw/:id',
                props: true,
                name: 'UsuarioEditPassword',
                meta: {
                    allowWithoutEmpresa: true,
                    title: "Edição de Senha de Usuário",
                },
                component: () => import('@pages/Usuario/UsuarioEditPassword.vue')
            },
            {
                path: 'usuario/show/:id',
                props: true,
                name: 'UsuarioShow',
                meta: {
                    allowWithoutEmpresa: true,
                    title: "Visualizar Usuário",
                },
                component: () => import('@pages/Usuario/UsuarioShow.vue')
            },
            {
                path: 'planocontas',
                props: true,
                name: 'PlanoContas',
                meta: {
                    title: "Plano de Contas",
                },
                component: () => import('@pages/PlanoContas/Index.vue')
            },
            {
                path: 'planocontas/create',
                name: 'PlanoContasCreate',
                meta: {
                    title: "Cadastro de Plano de Contas",
                },
                component: () => import('@pages/PlanoContas/PlanoContasCreate.vue')
            },
            {
                path: 'planocontas/edit/:id',
                props: true,
                name: 'PlanoContasEdit',
                meta: {
                    title: "Edição de Plano de Contas",
                },
                component: () => import('@pages/PlanoContas/PlanoContasEdit.vue')
            },
            {
                path: 'arquivos/',
                name: 'ArquivoList',
                meta: {
                    title: "Arquivos",
                },
                component: () => import('@pages/Arquivo/Index.vue')
            },
            {
                path: 'arquivos/upload',
                name: 'ArquivoUpload',
                meta: {
                    title: "Upload de Arquivos",
                },
                component: () => import('@pages/Arquivo/ArquivoUpload.vue')
            },
            {
                path: 'arquivo/:id',
                props: true,
                name: 'ArquivoShow',
                meta: {
                    title: "Arquivo",
                },
                component: () => import('@pages/Arquivo/ArquivoShow.vue')
            },

            /*{
                path: 'empresa/show',
                name: 'EmpresaShow',
                meta: {
                    title: "Visualizar Empresa",
                },
                component: () => import('@pages/Empresa/EmpresaShow.vue')
            },*/
            {
                path: 'meu-cadastro',
                props: true,
                name: 'UsuarioPerfil',
                meta: {
                    allowWithoutEmpresa: true,
                    title: "Perfil do Usuário",
                },
                component: () => import('@pages/Perfil/UsuarioPerfil')
            },
            {
                path: 'meu-cadastro/senha',
                props: true,
                name: 'UsuarioSenha',
                meta: {
                    allowWithoutEmpresa: true,
                    title: "Alteração de Senha",
                },
                component: () => import('@pages/Perfil/UsuarioSenha')
            },

        ]
    },
    {
        path: "/login",
        name: "Login",
        component: () => import('@pages/Auth/Login.vue'),
        //meta: {guest: true},
    },

]


const router = new VueRouter({
    mode: "history",
    routes
})

function loggedIn() {
    return store.state.isLogged;
}


const DEFAULT_TITLE = 'Nord Hotels';
router.afterEach((to, from) => {
    Vue.nextTick(() => {
        document.title = to.meta.title || DEFAULT_TITLE;
    });
})


router.beforeEach((to, from, next) => {

    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!loggedIn()) {
            next({
                path: '/login',
                query: {
                    redirect: to.fullPath
                }
            })
        } else {

            if (to.meta.permissions && to.meta.permissions === 'admin') {
                if (!store.state.isAdmin) {
                    store.state.modalNaoPermitido = true;
                    return
                }
            }

            const empresaSelecionada = store.state.empresa;
            if (!empresaSelecionada && !to.meta.allowWithoutEmpresa) {
                next({ name: 'EmpresaChange' });
            } else {
                next();
            }

        }
    } else if (to.matched.some(record => record.meta.guest)) {
        if (loggedIn()) {
            next({
                path: '/',
                query: {
                    redirect: to.fullPath
                }
            })
        } else {
            next()
        }
    } else {
        next()
    }
})

export default router
